import PropTypes from "prop-types";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import Backdrop from "@material-ui/core/Backdrop";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

const useStyles = makeStyles(theme => ({
  root: {
    transform: "translateZ(0px)",
    zIndex: 10
  },
  exampleWrapper: {
    position: "relative"
  },
  backdropRoot: {
    zIndex: 9
  },
  speedDial: {
    "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
      bottom: theme.spacing(2),
      right: theme.spacing(2)
    },
    "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
      top: theme.spacing(2),
      left: theme.spacing(2)
    }
  }
}));

export default function SpeedDials({ actions, defaultAction }) {
  const classes = useStyles();
  //const [direction, setDirection] = React.useState("up");
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <Backdrop open={open} className={classes.backdropRoot} />
      <div className={classes.root}>
        <div className="wrap-speedDial">
          <SpeedDial
            ariaLabel="SpeedDial menu"
            className={classes.speedDial}
            onClose={handleClose}
            onOpen={handleOpen}
            open={open}
            direction={"up"}
            icon={<AccountCircleIcon />}
            onClick={defaultAction}
          >
            {actions.map(action => (
              <SpeedDialAction
                key={action.name}
                icon={action.icon}
                tooltipTitle={action.name}
                onClick={action.action}
              />
            ))}
          </SpeedDial>
        </div>
      </div>
    </>
  );
}

SpeedDials.propTypes = {
  actions: PropTypes.array,
  defaultAction: PropTypes.func
};
